<ng-container *ngIf="cardData as data">
  <mat-accordion>
    <ng-container *ngFor="let card of cards() || []">
      <ng-container *ngComponentOutlet="card.component; injector: data()"></ng-container>
    </ng-container>
  </mat-accordion>
</ng-container>
